<ion-grid>
  <ion-row>
    <ion-col size="12">
      <div class="gv-fejlec">
        <ion-searchbar placeholder="Keresés név, azonosító vagy e-mail szerint"
                       [(ngModel)]="kereses" [debounce]="200"></ion-searchbar>
        <ion-button color="primary" (click)="uj()">
          <ion-icon slot="start" name="add"></ion-icon>
          Új gondviselő
        </ion-button>
      </div>

      <div *ngIf="toltodik" class="gv-uzenet"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>

      <ngx-datatable (select)="onSelect($event)"
        class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz selectable"
        [rows]="szurtLista" [sortType]="SortType.single" [columnMode]="ColumnMode.force" [limit]="15"
        [selected]="selected" [selectionType]="SelectionType.single" [rowClass]="getRowClass"
        [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">

        <ngx-datatable-column name="Név" prop="full_name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <b class="mobil">Név</b>
            {{ row.full_name }}
            <!-- A törvényes képviselő megkülönböztetése jogi kérdés: neki más jár. -->
            <ion-badge color="medium" *ngIf="!row.torv_kepv" title="Nem törvényes képviselő">kapcsolattartó</ion-badge>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Belépési azonosító" prop="username">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <b class="mobil">Belépési azonosító</b>{{ value }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Gyermek(ek)">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <b class="mobil">Gyermek(ek)</b>
            <span *ngFor="let gy of (row.gyermekek || []); let utolso = last">
              <ng-container *ngIf="gy">{{ gy.name }}<span *ngIf="gy.osztaly"> ({{ gy.osztaly }})</span>{{ utolso ? '' : ', ' }}</ng-container>
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Telefonszám" prop="telefon">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <b class="mobil">Telefonszám</b>{{ value }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="E-mail" prop="email">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <b class="mobil">E-mail</b>{{ value }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Műveletek" [sortable]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <b class="mobil">Műveletek</b>
            <ion-button color="secondary" size="small" style="margin-top:0" (click)="szerkeszt(row)"
                        title="Módosítás">
              <ion-icon slot="icon-only" name="create"></ion-icon>
            </ion-button>
            <ion-button color="danger" size="small" style="margin-top:0" (click)="torol(row)"
                        title="Törlés">
              <ion-icon slot="icon-only" name="trash"></ion-icon>
            </ion-button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </ion-col>
  </ion-row>
</ion-grid>

<ion-modal class="nagy" style="z-index: 1000" #uzenetmodal>
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel()">Mégse</ion-button>
        </ion-buttons>
        <ion-title>{{ urlap?.id ? 'Gondviselő módosítása' : 'Új gondviselő' }}</ion-title>
        <ion-buttons slot="end">
          <ion-button [strong]="true" [disabled]="ment" (click)="mentes()">
            {{ ment ? 'Mentés…' : 'Mentés' }}
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding" *ngIf="urlap">
      <ion-grid class="gv-urlap">
        <ion-row>
          <ion-col size="12"><h4>Név</h4></ion-col>
          <ion-col size="12" sizeMd="2">
            <ion-input label="Előtag" label-placement="stacked" fill="outline"
                       placeholder="dr." [(ngModel)]="urlap.elo"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="5">
            <ion-input label="Vezetéknév *" label-placement="stacked" fill="outline"
                       [(ngModel)]="urlap.vez"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="5">
            <ion-input label="Keresztnév *" label-placement="stacked" fill="outline"
                       [(ngModel)]="urlap.ker"></ion-input>
          </ion-col>

          <ion-col size="12" sizeMd="6">
            <ion-input label="Anyja vezetékneve" label-placement="stacked" fill="outline"
                       [(ngModel)]="urlap.anya_vez"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Anyja keresztneve" label-placement="stacked" fill="outline"
                       [(ngModel)]="urlap.anya_ker"></ion-input>
          </ion-col>

          <ion-col size="12" sizeMd="6">
            <ion-input label="Születési hely" label-placement="stacked" fill="outline"
                       [(ngModel)]="urlap.szul_hely"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Születési idő" label-placement="stacked" fill="outline" type="date"
                       [(ngModel)]="urlap.szul_ido"></ion-input>
          </ion-col>

          <ion-col size="12">
            <ion-item lines="none" class="gv-kapcsolo">
              <ion-toggle [(ngModel)]="urlap.torv_kepv" labelPlacement="end">
                Törvényes képviselő
              </ion-toggle>
            </ion-item>
            <!-- Ez nem formaság: a törvényes képviselő az, aki a gyerek ügyeiben
                 nyilatkozhat; a többi kapcsolattartó csak értesülhet. -->
            <ion-note color="medium">
              A törvényes képviselő nyilatkozhat a gyermek ügyeiben. Aki nem az, csak
              kapcsolattartó — értesítést kaphat, de nem jár el a gyermek nevében.
            </ion-note>
          </ion-col>

          <ion-col size="12"><h4>Belépés és elérhetőség</h4></ion-col>
          <ion-col size="12" sizeMd="4">
            <ion-input label="Belépési azonosító *" label-placement="stacked" fill="outline"
                       [(ngModel)]="urlap.username"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="4">
            <ion-input label="E-mail" label-placement="stacked" fill="outline" type="email"
                       [(ngModel)]="urlap.email"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="4">
            <ion-input label="Telefonszám" label-placement="stacked" fill="outline"
                       [(ngModel)]="urlap.telefon"></ion-input>
          </ion-col>
          <ion-col size="12">
            <ion-note color="medium">
              A <b>belépési azonosító</b> az, amivel a gondviselő belép, és erre hivatkozik a
              gyermek-hozzárendelés is. Átírásakor a hozzárendelést a rendszer átvezeti, de
              a gondviselőnek ezután az új azonosítóval kell belépnie.
            </ion-note>
          </ion-col>

          <!--  A BELÉPÉSI FIÓK. A gondviselő törzsadata rendben lehet, és mégsem tud
                belépni, ha a belépési rendszerben nincs fiókja – ez eddig sehol nem
                látszott, csak akkor derült ki, amikor a szülő szólt. Új gondviselőnél
                a mentés után jelenik meg, mert azonosító nélkül nincs mit keresni. -->
          <ion-col size="12" *ngIf="urlap.id && urlap.username">
            <app-belepes-fiok fajta="gondviselo"
                              [azonosito]="urlap.username"
                              [nev]="(urlap.vez || '') + ' ' + (urlap.ker || '')">
            </app-belepes-fiok>
          </ion-col>
          <ion-col size="12" *ngIf="!urlap.id">
            <ion-note color="medium">
              A belépési fiók a <b>mentés után</b> hozható létre — addig még nincs azonosító,
              amire a belépési rendszerben hivatkozni lehetne.
            </ion-note>
          </ion-col>

          <ion-col size="12"><h4>Állandó lakcím</h4></ion-col>
          <ion-col size="6" sizeMd="2">
            <ion-input label="Irányítószám" label-placement="stacked" fill="outline" type="number"
                       [(ngModel)]="urlap.irsz"></ion-input>
          </ion-col>
          <ion-col size="6" sizeMd="4">
            <ion-input label="Település" label-placement="stacked" fill="outline"
                       [(ngModel)]="urlap.telepules"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Cím" label-placement="stacked" fill="outline"
                       placeholder="közterület, házszám" [(ngModel)]="urlap.cim"></ion-input>
          </ion-col>

          <ion-col size="12">
            <h4>Tartózkodási cím
              <ion-button size="small" fill="clear" (click)="cimMasol()">
                <ion-icon slot="start" name="copy-outline"></ion-icon>
                Megegyezik az állandóval
              </ion-button>
            </h4>
          </ion-col>
          <ion-col size="6" sizeMd="2">
            <ion-input label="Irányítószám" label-placement="stacked" fill="outline" type="number"
                       [(ngModel)]="urlap.tart_irsz"></ion-input>
          </ion-col>
          <ion-col size="6" sizeMd="4">
            <ion-input label="Település" label-placement="stacked" fill="outline"
                       [(ngModel)]="urlap.tart_telepules"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Cím" label-placement="stacked" fill="outline"
                       [(ngModel)]="urlap.tart_cim"></ion-input>
          </ion-col>

          <ion-col size="12"><h4>Igazolvány</h4></ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Igazolvány típusa" label-placement="stacked" fill="outline"
                       placeholder="pl. személyazonosító igazolvány" [(ngModel)]="urlap.ig_tipus"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Igazolvány száma" label-placement="stacked" fill="outline"
                       [(ngModel)]="urlap.ig_szam"></ion-input>
          </ion-col>

          <!-- A gyerekek itt csak LÁTSZANAK: a hozzárendelés a Családok képernyőn
               történik, hogy a kapcsolat egy helyen legyen szerkeszthető. -->
          <ion-col size="12" *ngIf="urlap.gyermekek?.length">
            <h4>Gyermekei</h4>
            <ion-note color="medium">
              <span *ngFor="let gy of urlap.gyermekek; let utolso = last">
                {{ gy.name }}<span *ngIf="gy.osztaly"> ({{ gy.osztaly }})</span><span *ngIf="gy.rokonsag"> — {{ gy.rokonsag }}</span>{{ utolso ? '' : ' · ' }}
              </span>
              <br>A hozzárendelés a <b>Családok</b> képernyőn módosítható.
            </ion-note>
          </ion-col>

          <!-- SZÜLŐI FELÜGYELETI JOG gyermekenként (Nkt. 41. § (11)–(12), backend/felugyeleti-jog.js). A jelölés a
               szülő hozzáférését és értesítéseit szűkíti. A gondviselő mentésétől függetlenül, soronként ment. -->
          <ion-col size="12" *ngIf="urlap.id && kapcsolatok.length">
            <h4>Szülői felügyeleti jog</h4>
            <ion-note color="warning" *ngIf="!felugyeletMigracio">
              A felügyeleti jog még nem rögzíthető: a frissítés adatbázis-lépése nem futott le.
            </ion-note>
            <div class="gv-felugyelet" *ngFor="let k of kapcsolatok">
              <div class="gv-felugyelet-nev">
                <b>{{ k.tanulo_nev || k.tanulo }}</b><span *ngIf="k.rokonsag"> — {{ k.rokonsag }}</span>
                <small *ngIf="k.modositva"> · módosítva: {{ k.modositva }}<span *ngIf="k.modositotta"> ({{ k.modositotta }})</span></small>
              </div>
              <ion-select interface="popover" fill="outline" label="Felügyeleti jog" label-placement="stacked"
                          [(ngModel)]="k.uj_allapot" [disabled]="!felugyeletMigracio">
                <ion-select-option *ngFor="let a of felugyeletAllapotok" [value]="a.kod">{{ a.nev }}</ion-select-option>
              </ion-select>
              <ion-input fill="outline" label="Alapja (döntés száma, kelte)" label-placement="stacked"
                         [(ngModel)]="k.uj_megjegyzes" maxlength="500" [disabled]="!felugyeletMigracio"></ion-input>
              <ion-button size="small" (click)="felugyeletMentes(k)"
                          [disabled]="!felugyeletMigracio || !felugyeletValtozott(k) || felugyeletMent === k.id">Mentés</ion-button>
            </div>
            <ion-note color="medium">
              Alapból mindenki „teljes” — nála semmi nem változik. <b>Nem gyakorló</b> szülő (Nkt. 41. § (11)): csak a
              gyermek jegyeit, értékeléseit, bizonyítványát, mulasztásait és a jogviszony alapadatait látja, és csak
              ezekről kap értesítést; igazolást nem adhat be, feljegyzést, fegyelmit, étkezést, pénzügyet, kérvényt,
              órarendet, naptárt és a gyermek személyes adatait nem látja. <b>Korlátozott / megvont</b> (41. § (12)):
              a gyermek eltűnik a szülő felületéről, és róla semmilyen értesítést nem kap.
            </ion-note>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ng-template>
</ion-modal>
